import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=79d4d420&scoped=true&"
var script = {}
import style0 from "./PageLoader.vue?vue&type=style&index=0&id=79d4d420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d4d420",
  null
  
)

export default component.exports